import { ComponentType } from 'react'

import style from './style.scss'

type Props = {
  onClick: () => void
  children: string
  Icon: ComponentType<{ className?: string }>
}

function IconButton({ onClick, children, Icon }: Props) {
  return (
    <button className={style.wrapper} onClick={onClick}>
      <Icon className={style.icon} />
      {children}
    </button>
  )
}

export default IconButton
